/**
 * @deprecated If your app is using this selector please stop using it and provide a local selector isntead.
 */
export function getLeadReferenceId(state: any) {
    return state?.creditApp?.leadReferenceId || '';
}

/**
 * @deprecated If your app is using this selector please stop using it and provide a local selector isntead.
 */
export function getLeadReferenceTokenHash(state: any) {
    return state?.creditApp?.hash || '';
}

/**
 * @deprecated If your app is using this selector please stop using it and provide a local selector isntead.
 */
export function getLeadReferenceTokenTimestamp(state: any) {
    return state?.creditApp?.timestamp || '';
}

/**
 * @deprecated If your app is using this selector please stop using it and provide a local selector isntead.
 */
export function getCreditAppReferenceId(state: any) {
    return state?.creditApp?.creditAppReferenceId || '';
}

/**
 * @deprecated If your app is using this selector please stop using it and provide a local selector isntead.
 */
export function getAccelerateCreditAppId(state: any) {
    return state?.creditApp?.accelerateCreditAppId || '';
}
